goog.declareModuleId('yext.storm.partnerdashboard.init');

goog.require('yext.partneroverview');
import jsInit from '/js/yext/jsinit';

/**
* @param {{'urlPath': string}} params
*/
function initURLPath(params) {
  yext.partneroverview.init(params['urlPath']);
}

const init = jsInit({
  'partner-dashboard-init': initURLPath,
}, '.js-init-partner-dashboard');

document.addEventListener('DOMContentLoaded', init);
